import { SiTrackGrid } from '../../../../components/si-track-grid/si-track-grid';
import { WorkOrderLogColumns } from './work-order-log-columns';
import { useLoadData } from '../../../../hooks/useLoadData';
import { workorderReportApiKeyStore } from '../../../../api/workorder-report-api-key-store';
import { ApiResponse } from '../../../../models/api-response';
import { useParams } from 'react-router-dom';
import { UserPermissionName } from '../../../../models/user-permission-name';

const EmailLogList = () => {
  const { id } = useParams();
  const { data, isLoading, isFetching } = useLoadData<ApiResponse<any[]>>(
    workorderReportApiKeyStore.getEmailLog(Number(id))
  );

  return (
    <SiTrackGrid
      fileTitle='workorder_email_log'
      columns={WorkOrderLogColumns}
      dataItemKey="auditLogId"
      dataItems={data?.data}
        actionPermissions={{
          export: UserPermissionName.DOWNLOAD_GRID,
        }}
      isBusy={isLoading || isFetching}
    />
  );
};

export default EmailLogList;
